<template>
    <div id="app" class="layout">
        <template v-if="isFullScreen">
            <router-view></router-view>
        </template>
        <template v-else>
            <app-header></app-header>
            <div class="layout-container">
                <app-sidebar></app-sidebar>
                <router-view></router-view>
            </div>
            <app-footer></app-footer>
        </template>
        <app-back-top></app-back-top>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import AppBackTop from './components/AppBackTop';
import AppHeader from './components/AppHeader';
import AppSidebar from './components/AppSidebar';
import AppFooter from './components/AppFooter';
import jsCookie from 'js-cookie';

export default {
    name: 'App',
    components: {
        AppBackTop,
        AppHeader,
        AppSidebar,
        AppFooter
    },
    computed: {
        isFullScreen() {
            return !!this.$route.meta.isFullScreen || !Object.keys(this.$route.meta).length;
        }
    },
    methods: {
        ...mapActions(['USER_GET_PROFILE'])
    },
    created() {
        if (jsCookie.get(feConfig.cookie.key)) {
            this.USER_GET_PROFILE();
        }
    }
};
</script>

<style lang="scss">
@import '../../../node_modules/element-ui/lib/theme-chalk/index.css';
@import '../../assets/styles/main.scss';

#app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/views/index/App.vue